/*
 * @Author: panweikang
 * @Date: 2024-09-03 18:57:45
 * @LastEditTime: 2025-03-01 11:17:16
 * @Description: 
 */
import * as ActionTypes from "../ActionTypes";

const initialState = {
  temporaryVipStatus: '',
  authStatus: false,
};

const UserReducer = (state = initialState, action = "none") => {
  switch (action.type) {

    case ActionTypes.SET_TOKEN:
      return Object.assign({}, state, {
        token: action.token,
      });
    case ActionTypes.SET_USER_INFO:
      return Object.assign({}, state, {
        userInfo: action.userInfo,
      });

    case ActionTypes.SET_AUTH_STATUS:

      return Object.assign({}, state, {
        authStatus: action.authStatus,
      });

    case ActionTypes.SET_VIP_STATUS:

      return Object.assign({}, state, {
        temporaryVipStatus: action.temporaryVipStatus,
      });

    default:
      return state;
  }
};

export default UserReducer;
